<script setup lang="ts">
defineOptions({
  name: 'UiFormGroup',
});

defineProps({
  label: {
    type: String,
    default: null,
  },
  labelFor: {
    type: String,
    default: null,
  },
  tooltipText: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <section class="form-group">
    <div class="form-group__row">
      <label v-if="label" class="form-group__label" :for="labelFor"> {{ label }}{{ required ? '*' : '' }} </label>
      <UiTooltip v-if="tooltipText" class="form-group__tooltip" center-content>
        <template #contentSlot>
          {{ tooltipText }}
        </template>
        <i class="icon icon--tooltip-info" />
      </UiTooltip>
      <div class="form-group__content" :class="{ 'form-group__full-width': !label }">
        <slot />
      </div>
    </div>
    <div v-if="$slots.info" class="form-group__info">
      <slot name="info" />
    </div>
  </section>
</template>
